import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';

/**
 * Chargeback info related notice. Has 2 versions for u18 and o18
 */
const ChargebackInfoNoticePageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;

  let displayString = '';
  switch (punishmentData.verificationCategory) {
    case 'Email':
      displayString = translate('Label.EmailVerificationNotice');
      break;
    case 'VPC':
      displayString = translate('Label.ParentVerificationNotice');
      break;
    default:
      break;
  }
  return (
    <div data-testid='chargeback-info-notice'>
      <b>{displayString}</b>
    </div>
  );
};

const ChargebackInfoNoticePageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return !!punishmentData.verificationCategory;
  },
  renderComponent: ChargebackInfoNoticePageItem,
  configName: 'chargeback-info-notice'
};

export default ChargebackInfoNoticePageItemConfig;
